import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateBasicAdvancedChecked = mutatorAction('updateBasicAdvancedChecked', function (advancedChecked) {
    var store = connectedAccountsStore();
    store.connectBasicState.advancedChecked = advancedChecked;
});
//# sourceMappingURL=updateBasicAdvancedChecked.js.map